/**
 * Hours offset from UTC for the local timezone.
 * e.g. -6 for Mountain Time (MST), -5 for MDT.
 */
export const getUtcOffset = (): number => -new Date().getTimezoneOffset() / 60;
